$( document ).on('turbolinks:load', function() {
  if(document.getElementsByClassName('adsbygoogle').length > 1) (adsbygoogle = window.adsbygoogle || []).push({});

  window.yaContextCb=window.yaContextCb||[];
  if(mobileCheck()){
    postfix_class = 'Mob';
  }else{
    postfix_class = 'Pc';
  }
  var blocks = document.getElementsByClassName('JsYandexRtb'+postfix_class);
  Array.prototype.forEach.call(blocks, function(block) {
    window.yaContextCb.push(()=>{
      var block_id = $(block).data('block-id');
      Ya.Context.AdvManager.render({
        renderTo: 'yandex_rtb_'+block_id,
        blockId: block_id
      })
    })
  });

  if($('.JsScrolling').length > 0){
    window.addEventListener('scroll', () => {
      var scroll_button = $('#JsScrollingButton');
      if(scroll_button.length != 0 && $('.JsScrolling').length != 0 && $('#JsScrollingLoading').length == 0){
        var element = $('.JsScrolling');

        var contentHeight = element.height() + element.offset().top - 500;
        var yOffset       = window.pageYOffset;
        var window_height = window.innerHeight;
        var y             = yOffset + window_height;

        // если пользователь достиг конца
        if(y >= contentHeight){
          element.append("<div id='JsScrollingLoading' class='scrollingloading'><div class='lds-spinner'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>");
          scroll_button[0].click();
        }
      }
    });
  }
});

$(document).on('click', '.JsModalClick', function() {
  var element = $(this), title = '', text = '';
  switch(element.data('modal')){
    case 'addComplex':
      title = 'Добавить комплекс';
      text = 'Чтобы добавить информацию на наш сайт, оставьте Ваше Имя и телефон для связи <br> <br> Или напишите нам на почту <br><a href="mailto:info@relaf.ru" class="modal-link">info@relaf.ru</a>';
      break;
    case 'buyApart':
      title = 'Заявка на покупку квартиры';
      text = 'Оставьте Ваше Имя и телефон и мы поможем купить квартиру Вашей мечты';

      if($(this).data('complex')){
        $('<input>').attr({
          type: 'hidden',
          name: 'complex',
          value: $(this).data('complex')
        }).appendTo('#JsTicketForm');
      }

      if($(this).data('apart')){
        $('<input>').attr({
          type: 'hidden',
          name: 'apart',
          value: $(this).data('apart')
        }).appendTo('#JsTicketForm');
      }
      break;
  }
  $('#JsModalTitle').html(title);
  $('#JsModalText').html(text);
  $('#JsModals').show();
});

$(document).on('click', '#JsModalsModalClose', function() {
  $('#JsModals').hide();
});

$(document).on('click', '#JsModals', function(event) {
  if($(event.target).closest('#JsModal').length == 0) $('#JsModals').hide();
});

$(document).on('click', '.JsYandexMetrikaGoal', function(){
  var goal = $(event.target).attr('data-goal');
  if(goal == undefined) goal = $(event.target).parents('.JsYandexMetrikaGoal').attr('data-goal');
  yaCounter66259624.reachGoal(goal);
});

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

